import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation DeleteLongFormBuilderOutlineSection($id: ID!) {
    deleteLongFormBuilderOutlineSection(id: $id) {
      id
    }
  }
`;

export const deleteLongFormBuilderOutlineSection = (id) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { id },
  }).then(({ data }) => getSingleProp(data));
